import { useMutation } from '@tanstack/react-query';

import { message } from 'antd';

import { useTranslation } from 'react-i18next';

import { NSKeys } from '@app/i18n';
import { downloadExportedFile } from '@app/services/downloadExportedFile';

interface ExportResponse {
  filename?: string;
}

interface IProps<TParams, TData extends ExportResponse> {
  downloadPrefix: string;
  getFilePath: (filename: string) => string;
  mutationFn: (params: TParams) => Promise<TData>;
}

export const useExportDownload = <TParams, TData extends ExportResponse = ExportResponse>({
  downloadPrefix,
  getFilePath,
  mutationFn,
}: IProps<TParams, TData>) => {
  const commonT = useTranslation(NSKeys.common);

  return useMutation<TData, unknown, TParams>({
    mutationFn,
    onError: () => {
      message.open({
        type: 'error',
        content: commonT.t('error400'),
      });
    },
    onSuccess: (data) => {
      if (data?.filename) {
        downloadExportedFile({
          downloadName: `${downloadPrefix}-${new Date().getUTCDate()}`,
          path: getFilePath(data.filename),
        });
      }
    },
  });
};
